import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col justify-start z-10 box-border absolute rounded-md border-b-4 p-1 transition-colors cursor-pointer select-none f-clickable", _ctx.classCourseCard]),
    style: _normalizeStyle([_ctx.styleCourseCard, {"width":"calc(100% - 0.125rem)","left":"0.0625rem"}]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickCourseCard && _ctx.handleClickCourseCard(...args))),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setHoveredCourseId(_ctx.section.id))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetHoveredCourseId && _ctx.resetHoveredCourseId(...args))),
    onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setHoveredCourseId(_ctx.section.id))),
    onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetHoveredCourseId && _ctx.resetHoveredCourseId(...args)))
  }, [
    _createElementVNode("span", {
      class: "break-all overflow-ellipsis overflow-hidden text-xs font-semibold",
      style: _normalizeStyle([{"display":"-webkit-box","-webkit-box-orient":"vertical"}, { '-webkit-line-clamp': _ctx.lines.name }])
    }, _toDisplayString(_ctx.section.name), 5),
    (_ctx.lines.code > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "break-all overflow-ellipsis overflow-hidden text-xxs",
          style: _normalizeStyle([{"display":"-webkit-box","-webkit-box-orient":"vertical"}, { '-webkit-line-clamp': _ctx.lines.code }])
        }, _toDisplayString(`(${_ctx.section.codeId})`), 5))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "break-all overflow-ellipsis overflow-hidden text-xxs",
      style: _normalizeStyle([{"display":"-webkit-box","-webkit-box-orient":"vertical"}, { '-webkit-line-clamp': _ctx.lines.place }])
    }, _toDisplayString(_ctx.placeString), 5)
  ], 38))
}